// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3AOkQ","content":"Consent_content__24h-v","footer":"Consent_footer__vR7qI"};